// extracted by mini-css-extract-plugin
module.exports = {"view":"foundation_view_zLcXd","content":"foundation_content_2CgjC"};